module.exports = __webpack_public_path__ + "img/274.750727f9.png";